/**
 * Format a date string to a Dutch locale string.
 * @param dateStr - ISO date string to format
 * @param dateOptions - Optional Intl.DateTimeFormatOptions (defaults to short month)
 */
export function formatDate(
  dateStr: string,
  dateOptions: Intl.DateTimeFormatOptions = {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  }
): string {
  return new Intl.DateTimeFormat('nl-NL', dateOptions).format(new Date(dateStr))
}
